import * as React from "react"
import {observer} from "mobx-react"
import {i18n} from "@cling/lib.web.i18n"
import {ui_state} from "../state/index"
import {running_on_mobile_device} from "@cling/lib.web.utils"
import {classNames} from "@cling/lib.web.utils"
import {import_data_state} from "./import_data_state"
import {runInAction} from "mobx"

export const ImportDataToast = observer(() => {
    const {job_status} = import_data_state
    const ref = React.useCallback((elm?: ReactRef<HTMLDivElement>) => {
        runInAction(() => {
            ui_state.toast_shown = !!elm
        })
    }, [])
    if (!job_status) {
        return null
    }
    return (
        <div
            className={classNames("toast", {
                "toast--with-bottom-app-bar": running_on_mobile_device() && ui_state.app_bar_shown,
            })}
            ref={ref}
        >
            <span className="toast__text">{i18n.importing_data}</span>
            <progress
                className="toast__progress_bar"
                value={Math.round(import_data_state.progress_value)}
                max={import_data_state.progress_max}
            />
        </div>
    )
})
